const getBaseUrl = (uri: string) => {
  if(!uri) {
    throw new Error('no uri')
  }
  return uri
}

export const HOST = getBaseUrl(window.location.origin)
